<template>
  <form-item v-bind="$attrs" v-on="$listeners" class-name="Status" :prop="prop">
    <enable-select v-model="model[prop]"></enable-select>
  </form-item>
</template>

<script>
  import FormItem from '@/components/form/FormItem'
  import EnableSelect from '@/components/selector/EnableSelect'

  export default {
    name: 'StatusFormItem',
    props: {
      prop: {
        type: String,
        default: 'status'
      }
    },
    components: {
      EnableSelect,
      FormItem
    },
    computed: {
      model () {
        let parent = this.$parent
        while (parent) {
          if (parent.model != null) return parent.model
          parent = parent.$parent
        }
        return null
      }
    }
  }
</script>
